import React, { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router";
import { HiOutlineArrowTurnRightDown } from "react-icons/hi2";
import { MdContentCopy } from "react-icons/md";
import { ToastSuccess } from "../global/component";
import { ToastContainer } from "react-toastify";
import AuthContext from "../global/auth-context";
import { FaRocket } from "react-icons/fa6";
import { FaBoxOpen } from "react-icons/fa";
import CopyToClipboard from "react-copy-to-clipboard";
import { Analytics } from "@vercel/analytics/react";

const PremiumTips = () => {
  let { user, userData, isAuth, premiumTips } = useContext(AuthContext);
  let navigate = useNavigate();
  async function CopyCode(params) {
    ToastSuccess("Code Copied");
  }

  if (!isAuth || (isAuth && userData.role == "free")) {
    return (
      <div className="flex flex-col justify-center items-center py-10 gap-5">
        <FaRocket className="text-7xl" color="#016401" />
        <text className="font-medium text-black text-xl lg:text-2xl">
          Dream Big, Win Bigger!
        </text>
        <a
          href={"/premium"}
          className="bg-white px-5 py-2 rounded-full text-xl text-myNormalGreen font-bold border-2 border-myNormalGreen"
        >
          LET'S GO
        </a>
      </div>
    );
  }

  return (
    <>
      {isAuth && userData.role != "free" && premiumTips.length > 0 && (
        <>
          <ToastContainer />
          <div className="flex py-10 px-5 w-full justify-center items-center gap-3 flex-wrap">
            {premiumTips.map((item, index) => {
              return (
                <div
                  key={item.id}
                  className="w-screen h-fit bg-white rounded-2xl border-2 border-myDarkGreen justify-between flex lg:w-96 md:w-96 sm:w-96"
                  style={{
                    boxShadow: 10,
                  }}
                >
                  <div className="flex self-start w-1/2 p-5 gap-2 flex-col">
                    <text className="text-lg font-bold text-myNormalGreen">
                      {item.numberOfGames}{" "}
                      {item.numberOfGames < 2 ? "Match" : "Matches"}
                    </text>
                    <div className="flex ">
                      <text className="font-medium text-black">
                        {item.bookie} code
                      </text>
                      <HiOutlineArrowTurnRightDown size={20} color="black" />
                    </div>
                    {/* <AlertNotificationRoot> */}
                    <CopyToClipboard text={item.code}>
                      <Link
                        onClick={() => {
                          CopyCode(item.id);
                          // copytext(data.id);
                          // console.log(data.id);
                        }}
                        className="flex gap-1 items-center bg-myNormalGreen py-2 rounded-2xl w-fit px-5"
                      >
                        <text className="text-sm text-white font-medium text-center ">
                          {item.code}
                        </text>
                        <MdContentCopy size={18} color="white" />
                      </Link>
                    </CopyToClipboard>
                    {/* </AlertNotificationRoot> */}
                  </div>
                  <div
                    className="bg-myNormalGreen w-1/2 flex flex-col pr-5  items-end justify-around"
                    style={{
                      borderTopLeftRadius: 100,
                      borderTopRightRadius: 10,
                      borderBottomRightRadius: 10,
                    }}
                  >
                    <text className="font-bold text-white text-lg">
                      {item.totalOdds} Odds
                    </text>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/premiumTips/${item.code}`);
                        window.scrollTo(0, 0);
                      }}
                      className="bg-white py-1 px-3 rounded-2xl"
                      title="View Free Games List"
                    >
                      <text className="text-center text-myNormalGreen font-medium text-lg">
                        View Games
                      </text>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
      {isAuth && userData.role != "free" && premiumTips.length < 1 && (
        <div className="flex flex-col justify-center items-center py-10 gap-5">
          <FaBoxOpen className="text-7xl" color="#016401" />
          <text className="font-medium text-black text-xl lg:text-2xl">
            No Premium Tips Available
          </text>
        </div>
      )}
    </>
  );
};

export default PremiumTips;
